import { http } from "../utils/http";

/** Personal UI settings of the signed-in user (backend /v1/ui-preferences). Правка №5. [Claude] 2026-11-02 */
export const getMenuPrefs = () => http.get("/ui-preferences/menu");
export const saveMenuPrefs = (prefs) => http.put("/ui-preferences/menu", prefs);

/** Personal table layouts, key e.g. "employees_table" (правка №15, Чат 4). [Claude] 2026-11-02 */
export const getTablePrefs = (key) => http.get(`/ui-preferences/${encodeURIComponent(key)}`);
export const saveTablePrefs = (key, prefs) => http.put(`/ui-preferences/${encodeURIComponent(key)}`, prefs);
